import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: white;
  }

  .navbar {
    position: fixed;

    width: -webkit-fill-available;
    width: -moz-available; 
    width: fill-available;
}
`;

export const PageWrapper = styled.div`
    padding: 90px 74px 0px 74px;
`;

export const ReportsPageTitle = styled.h3`
    font-size: 24.5px;
    font-weight: 500;
    line-height: 29px;
    margin-bottom: 28px;
`;


export const ReportsTab = styled.ul`
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 25px;

    li a{
        padding: 14px;
        cursor: pointer;
    }
    
    .nav-item a {
        color: #6C757D;

        i {
            padding-right: 5px;
            font-size: 14px;
        }
    }

    .nav-item a:hover {
        border: none;
        border-bottom: 1px solid #46389E;
    }

    .nav-item .active {
        color: #5341C6;
        border: none;
        border-bottom: 1px solid #46389E;
        background-color: rgba(104, 96, 228, 0.04);
    }
`;
